import { CARREGAR_CIDADES_SUCESSO } from '../actions/actionTypes';
import initialState from './initialState.reducer';

export default (state = initialState.cidades, action) => {
  if (action.type === CARREGAR_CIDADES_SUCESSO)
    return action.cidades;

  return state;
};